<template>
  <div class="events-count">
    <Title :img="triangleImg" :name="'近一周事件统计'" :callback="onDetail"/>
    <div class="events-count-content">
      <div class="statistics">
        <div class="stat-item">
          <div class="value">{{ totalEvents }}</div>
          <div class="label">总事件数</div>
        </div>
        <div class="stat-item">
          <div class="value">{{ resolvedEvents }}</div>
          <div class="label">已解决事件</div>
        </div>
        <div class="stat-item">
          <div class="value">{{ resolutionRate }}</div>
          <div class="label">解决率</div>
        </div>
      </div>
      <div ref="chartContainer" class="chart-container" v-chart-resize></div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/title/title.vue'
import triangleImg from '@/assets/image/triangle.png'
import * as echarts from 'echarts'
import {markRaw} from "vue";

export default {
  name: 'EventsCount',
  components: { Title},
  data() {
    return {
      triangleImg: triangleImg,
      chart: null,
      totalEvents: 142,
      resolvedEvents: 118,
      resolutionRate: '83.1%',
      chartData: {
        dates: ['06-01', '06-02', '06-03', '06-04', '06-05', '06-06', '06-07'],
        series: [
          {
            name: '泊车问题-总数',
            data: [5, 7, 4, 6, 8, 5, 4]
          },
          {
            name: '泊车问题-已解决',
            data: [4, 6, 3, 5, 7, 4, 3]
          },
          {
            name: '垃圾处理-总数',
            data: [8, 6, 9, 7, 5, 10, 7]
          },
          {
            name: '垃圾处理-已解决',
            data: [7, 5, 8, 6, 4, 9, 6]
          },
          {
            name: '草坪维护-总数',
            data: [3, 4, 2, 5, 3, 4, 2]
          },
          {
            name: '草坪维护-已解决',
            data: [2, 3, 2, 4, 3, 3, 1]
          },
          {
            name: '井盖问题-总数',
            data: [2, 1, 3, 2, 1, 3, 2]
          },
          {
            name: '井盖问题-已解决',
            data: [1, 1, 2, 1, 0, 2, 1]
          }
        ]
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.dispose()
    }
  },
  methods: {
    onDetail(){
      this.$router.push({ path: "/events-center" });
    },
    initChart() {
      if (!this.$refs.chartContainer) return

      if (this.chart) {
        this.chart.dispose()
      }

      this.chart = markRaw(echarts.init(this.$refs.chartContainer))

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['泊车问题', '垃圾处理', '草坪维护', '井盖问题'],
          textStyle: {
            color: '#fff'
          },
          top: 0
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.chartData.dates,
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          axisLabel: {
            color: '#fff'
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          axisLabel: {
            color: '#fff'
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.1)'
            }
          }
        },
        series: [
          {
            name: '泊车问题',
            type: 'bar',
            stack: '总量',
            itemStyle: {
              color: '#9aeeff'
            },
            data: this.chartData.series[0].data
          },
          {
            name: '垃圾处理',
            type: 'bar',
            stack: '总量',
            itemStyle: {
              color: '#4ECDC4'
            },
            data: this.chartData.series[2].data
          },
          {
            name: '草坪维护',
            type: 'bar',
            stack: '总量',
            itemStyle: {
              color: '#3ec447'
            },
            data: this.chartData.series[4].data
          },
          {
            name: '井盖问题',
            type: 'bar',
            stack: '总量',
            itemStyle: {
              color: '#42acff'
            },
            data: this.chartData.series[6].data
          }
        ]
      }

      this.chart.setOption(option)
    }
  }
}
</script>

<style lang="less" scoped>
.events-count {
  position: absolute;
  bottom: 1rem;
  height: 60%;
  width: 100%;
  border-radius: 5px;
  padding: 0.5rem;
  background: /* 左上角圆形渐变 */ radial-gradient(circle at left top, #c8aca2, #171e2127 5%) no-repeat,
    /* 右上角圆形渐变 */ radial-gradient(circle at right top, #c8aca2, #171e2127 5%) no-repeat,
    /* 中间半透明背景 */ linear-gradient(to bottom, #171e2127, #171e2127);

  .events-count-content {
    height: calc(100% - 2rem);
    width: 100%;

    .statistics {
      display: flex;
      justify-content: space-around;
      margin-bottom: 1rem;

      .stat-item {
        text-align: center;
        color: #fff;

        .value {
          font-size: 1.5rem;
          font-weight: bold;
          margin-bottom: 0.2rem;
        }

        .label {
          font-size: 0.8rem;
          opacity: 0.8;
        }
      }
    }

    .chart-container {
      width: 100%;
      height: calc(100% - 4rem);
    }
  }
}
</style>